import { Factory } from "@/data/dao/Factory";
import { LocationDao } from "@/data/dao/service/LocationDao";
import type { ILocationDetail } from "@/data/model/Location";

import { logError } from "@/shared/logging/errors";
import { style } from "@/shared/ui/Style";

import { i18n } from "@/portal/Trans";
import { UiNotification } from "@/portal/ui/Notification";

export class TwilioConnector {
    private $element: JQuery;
    private location?: ILocationDetail;

    constructor(element: JQuery) {
        this.$element = element;
    }

    public setByLocation(restauratDetail: ILocationDetail): TwilioConnector {
        this.location = restauratDetail;

        if (this.location.twilioAccount === undefined) this.setDisabled();
        else this.setEnabled();

        return this;
    }

    private setDisabled() {
        this.$element.empty();

        const btn = $('<button class="btn btn-success">' + i18n("general.activate") + "</button>").appendTo(
            this.$element
        );
        btn.click(() => {
            UiNotification.confirm(
                i18n("location.twilio.reallyCreate"),
                undefined,
                () => {
                    btn.addClass(style.buttonLoaderClass).prop("disabled", true);
                    Factory.getInstance<LocationDao>(LocationDao)
                        .activateTwilioAccount(this.location!.id)
                        .then((e) => {
                            this.location!.twilioAccount = e;
                            this.setEnabled();

                            UiNotification.showSuccess(i18n("location.twilio.created"));
                        })
                        .catch((ex) => {
                            logError(ex);
                            UiNotification.showException(i18n("location.twilio.failedCreate"));
                            btn.removeClass(style.buttonLoaderClass).prop("disabled", false);
                        });
                },
                i18n("location.twilio.create")
            );
        });
    }

    private setEnabled() {
        this.$element.empty();

        const info = $('<div class="infos" />').appendTo(this.$element);
        info.append("<p>" + i18n("location.twilio.currentConnected") + ":</p>");
        info.append(
            '<div class="accinfo"><span class="key">' +
                i18n("location.twilio.accountSid") +
                ':</span><span class="value">' +
                this.location!.twilioAccount!.sid +
                "</span></div>"
        );
        info.append(
            '<div class="accinfo"><span class="key">' +
                i18n("location.twilio.serviceSid") +
                ':</span><span class="value">' +
                this.location!.twilioAccount!.serviceId +
                "</span></div>"
        );

        const btn = $('<button class="btn btn-danger">' + i18n("general.deactivate") + "</button>").appendTo(
            this.$element
        );
        btn.click(() => {
            UiNotification.confirm(
                i18n("location.twilio.reallyDelete"),
                undefined,
                () => {
                    btn.addClass(style.buttonLoaderClass).prop("disabled", true);

                    Factory.getInstance<LocationDao>(LocationDao)
                        .disableTwilioAccount(this.location!.id)
                        .then(() => {
                            this.location!.twilioAccount = undefined;
                            this.setDisabled();

                            UiNotification.showSuccess(i18n("location.twilio.deleted"));
                        })
                        .catch((ex) => {
                            logError(ex);
                            UiNotification.showException(i18n("location.twilio.failedDelete"));
                            btn.removeClass(style.buttonLoaderClass).prop("disabled", false);
                        });
                },
                i18n("location.twilio.delete")
            );
        });
    }
}
